(function () {
  const ZOOM_SCALE = 2.5;
  const desktopQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  function setup(opener) {
    const zoom = opener.querySelector('.product__media-zoom');
    if (!zoom || opener.dataset.hoverZoom) return;
    opener.dataset.hoverZoom = 'true';

    const move = (event) => {
      const rect = zoom.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      zoom.style.backgroundPosition = `${Math.min(Math.max(x, 0), 100)}% ${Math.min(Math.max(y, 0), 100)}%`;
    };

    let hovering = false;
    let loaded = false;
    let loading = false;

    // Keep the zoom layer hidden until the large image has loaded, so the
    // normal photo stays visible instead of flashing a blank layer.
    const load = () => {
      if (loaded || loading) return;
      loading = true;
      const image = new Image();
      image.onload = () => {
        zoom.style.backgroundImage = `url("${zoom.dataset.zoomSrc}")`;
        zoom.style.backgroundSize = `${ZOOM_SCALE * 100}%`;
        loaded = true;
        if (hovering) zoom.classList.add('is-active');
      };
      image.onerror = () => {
        loading = false;
      };
      image.src = zoom.dataset.zoomSrc;
    };

    opener.addEventListener('mouseenter', (event) => {
      if (!desktopQuery.matches) return;
      hovering = true;
      move(event);
      if (loaded) {
        zoom.classList.add('is-active');
      } else {
        load();
      }
    });
    opener.addEventListener('mousemove', (event) => {
      if (hovering) move(event);
    });
    opener.addEventListener('mouseleave', () => {
      hovering = false;
      zoom.classList.remove('is-active');
    });
  }

  function init() {
    document.querySelectorAll('.product__modal-opener--image').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
